import { useEffect, useState } from "react";
import { Form, Col, Row, Checkbox, Divider } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import {
  CheckCircleOutlined,
  CloseOutlined,
  DesktopOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
  InfoCircleOutlined,
  SettingOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import CustomCheckbox from "../../../global/components/inputWidgets/CustomCheckBox";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import SingleSelectCheckboxGroup from "../../../global/components/inputWidgets/SingleSelectCheckboxGroup";

export const LicenseForm = ({
  type,
  isModalForm,
  onCancel,
  setDefaultData,
}) => {
  const [showModal, setShowModal] = useState(false);
  // const [isInitial, setInitial] = useState(true);
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [siteType, setSiteType] = useState(0);
  // const [selectedValues, setSelectedValues] = useState([]);
  // const [sitetype, setSiteType] = useState(0);

  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/licenses/${id}/`
    : `${process.env.REACT_APP_API_URL}/api/licenses/`;
  // const postUrl = `${process.env.REACT_APP_API_URL}/api/licenses/`;
  // const putUrl = `${process.env.REACT_APP_API_URL}/api/licenses/${id}/`;
  // const deleteUrl = `${process.env.REACT_APP_API_URL}/api/licenses/${id}/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/options/`;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);

  // console.log("optionData", optionData);

  // const modifiedLicenseTypes = getModifiedResponse(optionData, "licensetypes");
  const modifiedProducts = getModifiedResponse(optionData, "products");
  // const modifiedOldModels = getModifiedResponse(optionData, "oldmodels");
  const modifiedModels = getModifiedResponse(optionData, "models");
  const modifiedSiteTypes = getModifiedResponse(optionData, "sitetype");

  // const modifiedOems = getModifiedResponse(optionData, "oems");
  // const modifiedOp =
  //   optionData?.data?.options?.map((item) => ({
  //     label: item.name,
  //     value: item.value,
  //     tag: item.tag.toLowerCase().replace(/\s+/g, ""),
  //   })) || [];

  const modifiedOp = optionData?.data?.options?.map((entry, index) => {
    // const safeName = entry?.name?.replace(/\s+/g, "_")?.toLowerCase();
    // const safeTag = entry?.tag?.replace(/\s+/g, "_")?.toLowerCase();

    return {
      value: `${entry?.value}`,
      // tag: entry.tag.toLowerCase().replace(/\s+/g, ""),
      label: entry.name,
    };
  });

  // const modifiedOpValues =
  //   selectedValues?.length > 0
  //     ? selectedValues.map((val) => {
  //         const [item, originalValue] = val?.split("-");
  //         return [Number(item), Number(originalValue)];
  //       })
  //     : [];

  // console.log("modifiedOp", modifiedOp);

  // const createModifiedOptions = (data, key) => [
  //   // { label: "N/A", value: null },
  //   ...getModifiedResponse(data, key),
  // ];

  // const modifiedOptions = {
  //   channels: createModifiedOptions(optionData, "channels"),
  //   facegates: createModifiedOptions(optionData, "facegates"),
  //   locksets: createModifiedOptions(optionData, "locksets"),
  //   contLocks: createModifiedOptions(optionData, "contlocks"),
  //   subnodes: createModifiedOptions(optionData, "subnodes"),
  //   intercoms: createModifiedOptions(optionData, "intercoms"),
  //   sicucoms: createModifiedOptions(optionData, "sicucoms"),
  //   invitations: createModifiedOptions(optionData, "invitations"),
  //   storages: createModifiedOptions(optionData, "storages"),
  // };
  // const {
  //   channels: modifiedChannels,
  //   facegates: modifiedFacegates,
  //   locksets: modifiedLocksets,
  //   contLocks: modifiedContLocks,
  //   subnodes: modifiedSubnodes,
  //   intercoms: modifiedIntercoms,
  //   sicucoms: modifiedSicucoms,
  //   invitations: modifiedInvitations,
  //   storages: modifiedStorages,
  // } = modifiedOptions;

  // console.log("modifiedOp", modifiedOp);

  const { data, loading, error, refetch } = useGet(url);

  // console.log(modifiedOp);

  // console.log("data", data);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(url);

  const {
    data: putData,
    loading: putLoading,
    error: putError,
    putData: putAction,
  } = usePut(url);
  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteData,
  } = useDelete(url);

  const onFinish = async (values) => {
    try {
      if (id) {
        const modifiedValue = {
          ...values,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom ? values.Sicucom / 100 : 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
          Monthly: values.Monthly
            ? Number(parseFloat(values.Monthly).toFixed(2))
            : values.Monthly,
          OneTime: values.OneTime
            ? Number(parseFloat(values.OneTime).toFixed(2))
            : values.OneTime,
        };
        await putAction(modifiedValue);
      } else {
        const modifiedValue = {
          ...values,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom ? values.Sicucom / 100 : 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
          // Monthly: values.Monthly
          //   ? Number(parseFloat(values.Monthly).toFixed(2))
          //   : values.Monthly,
          // OneTime: values.OneTime
          //   ? Number(parseFloat(values.OneTime).toFixed(2))
          //   : values.OneTime,
        };
        // console.log("modifiedValue", modifiedValue);
        await postAction(modifiedValue);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    // form.resetFields();
    isModalForm ? onCancel() : navigate("/license");
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  // Set default field value for create not a valid undefined field
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        // OemNo: modifiedOems[0]?.value,
        // Product: modifiedProducts[0]?.value,
        Model: modifiedModels[0]?.value,
        // SiteType: modifiedSiteTypes[0]?.value,
        // Channel: modifiedChannels[0]?.value,
        // Lockset: modifiedLocksets[0]?.value,
        // Facegate: modifiedFacegates[0]?.value,
        // Subnode: modifiedSubnodes[0]?.value,
        // ContLock: modifiedContLocks[0]?.value,
        // Intercom: modifiedIntercoms[0]?.value,
        // Sicucom: modifiedSicucoms[0]?.value,
        // Invitation: modifiedInvitations[0]?.value,
        // Storage: modifiedStorages[0]?.value,
      });
    }
  }, [optionData]);

  // useEffect(() => {
  //   if (!id) return;
  //   else {
  //     if (data?.data?.LicenseType == 0) {
  //       setInitial(true);
  //     } else {
  //       setInitial(false);
  //     }
  //   }
  // }, [data]);
  // console.log({ data });

  useEffect(() => {
    if (!id || loading) return;
    const getAccountInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            LicenseName: String(data?.data?.LicenseName),
            LicenseDesc: data?.data?.LicenseDesc
              ? String(data.data.LicenseDesc)
              : "",
            // LicenseType: data.data.LicenseType,
            // Product: data.data.Product,
            // OldModel: data.data.OldModel,
            Model: data.data.Model,
            // OldType: String(data.data.OldType),
            Type: data.data.Type,
            // SiteType: data.data.SiteType,
            // OemNo: data.data.OemNo,
            Options: data.data.Options?.map((item) => String(item)),
            // Camera: String(data.data.Camera),
            Channel: data.data.Channel,
            Lockset: data.data.Lockset,
            ContLock: data.data.ContLock,
            Facegate: data.data.Facegate,
            Subnode: data.data.Subnode,
            // Storage: data.data.Storage,
            Intercom: data.data.Intercom,
            Sicucom: data.data.Sicucom ? data.data.Sicucom * 100 : null,
            Invitation: data.data.Invitation
              ? data.data.Invitation * 100
              : null,
            // Monthly: data?.data?.Monthly || "",
            // OneTime: data?.data?.OneTime || "",
          });
          // setSiteType(data?.data?.SiteType);

          // if (data.data.Options && modifiedOp) {
          //   const filtered = modifiedOp
          //     .filter((op) => {
          //       const [item, originalValue] = op?.value?.split("-");
          //       return data?.data?.Options.some(
          //         ([selectedItem, selectedOriginalValue]) =>
          //           Number(item) === selectedItem &&
          //           Number(originalValue) === selectedOriginalValue
          //       );
          //     })
          //     .map((op) => op.value);
          // setSelectedValues(filtered || []);
          // }
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        if (!loading) {
          console.log({ error });
          openErrorNotification("Error fetching data!");
        }
      }
    };

    getAccountInfoById();
  }, [id, data, loading, form, type]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      setDefaultData &&
        setDefaultData({
          LicenseNo: postData?.data?.LicenseNo,
        });
      setTimeout(() => {
        isModalForm ? onCancel() : navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putLoading && !putError && putData) {
      openConfirmNotification("Success");
      setDefaultData &&
        setDefaultData({
          LicenseNo: postData?.data?.LicenseNo,
        });
      refetch();
      setTimeout(() => {
        isModalForm ? onCancel() : navigate(-1);
      }, 200);
    }
  }, [putData, putLoading, putError]);

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      // refetch();
      navigate("/license");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  const breadcrumbItems = [
    {
      label: "License",
      href: "/license",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/license/info/${id}`
          : `/license/edit/${id}`
        : "/license/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "Edit",
            icon: <EditOutlined />,
            onClick: () => {
              navigate(`/license/edit/${id}`);
            },
          },
          {
            label: "Delete",
            icon: <DeleteOutlined />,
            onClick: () => {
              setShowModal(true);
            },
          },
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ]
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
            <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
              <CommonButton buttonsData={buttonsData} />
            </CommonBreadcrumb>
          </div>

          <>
            <div className="border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <LicenseIcon className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Name"
                      name="LicenseName"
                      disabled={type === "info"}
                      required
                      loading={loading}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Description"
                      name="LicenseDesc"
                      disabled={type === "info"}
                      loading={loading}
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="mt-3 border bg-white rounded-[4px] overflow-hidden">
              <div className="bg-gray-200 p-2.5 flex items-center">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License Information
                </span>
              </div>
              <div>
                {/* {isInitial ? ( */}
                <div className="px-2 pt-1 pb-3">
                  <Row gutter={[16, 8]}>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomSelect
                          label="Product"
                          name="Product"
                          options={modifiedProducts}
                          placeholder="Please select"
                          disabled={type === "info"}
                          required
                        />
                      </Col> */}
                    {/* {console.log(form.getFieldValue("SiteType"))} */}

                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomSelect
                          label="Site Type"
                          name="SiteType"
                          options={
                            ["edit", "info"].includes(type)
                              ? siteType === 3
                                ? modifiedSiteTypes?.filter(
                                    (item) => item.value === 3
                                  )
                                : siteType === 4
                                ? modifiedSiteTypes?.filter(
                                    (item) => item.value === 4
                                  )
                                : modifiedSiteTypes?.filter(
                                    (item) => ![3, 4].includes(item.value)
                                  )
                              : modifiedSiteTypes
                          }
                          placeholder="Please select"
                          // onChange={(value) => {
                          //   setSiteType(value);
                          // }}
                          disabled={type === "info"}
                          required
                          loading={loading}
                        />
                      </Col> */}

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Model"
                        name="Model"
                        options={modifiedModels}
                        placeholder="Please select"
                        disabled={type === "info"}
                        required
                        loading={loading}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Door"
                        name="Type"
                        disabled={type === "info"}
                        type="number"
                        required
                        loading={loading}
                        rules={[
                          {
                            required: true,
                            message: "Door is required",
                          },
                          {
                            validator: (_, value) => {
                              if (value && value > 65535) {
                                return Promise.reject(
                                  new Error(
                                    "Door must be less than or equal to 65535!"
                                  )
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      />
                    </Col>
                  </Row>
                  {/* <Row gutter={[16, 8]}> */}
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <CustomInput
                            label="Type"
                            name="Type"
                            disabled={type === "info"}
                            type="number"
                            required
                          />
                        </Col> */}
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomSelect
                          label="OEM"
                          name="OemNo"
                          options={modifiedOems}
                          placeholder="Please select"
                          disabled={type === "info"}
                          required
                        />
                      </Col> */}
                  {/* </Row> */}
                </div>

                {/* ) : (
                    <div className="px-2 pt-1 pb-3">
                      <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <CustomSelect
                            label="Old Model"
                            name="OldModel"
                            options={modifiedOldModels}
                            placeholder="Please select"
                            disabled={type === "info"}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <CustomSelect
                            label="Model"
                            name="Model"
                            options={modifiedModels}
                            placeholder="Please select"
                            disabled={type === "info"}
                          />
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <CustomInput
                            label="Old Type"
                            name="OldType"
                            disabled={type === "info"}
                            type="number"
                            required
                          />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                          <CustomInput
                            label="Type"
                            name="Type"
                            disabled={type === "info"}
                            type="number"
                            required
                          />
                        </Col>
                      </Row>
                    </div>
                  )} */}
              </div>
            </div>
            <div className="mt-3 border bg-white rounded-[4px] overflow-hidden ">
              <div className="bg-gray-200 p-2.5 flex items-center">
                <SettingOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License Options
                </span>
              </div>
              <div
                className={`px-2 py-3 grid gap-4 ${
                  isModalForm ? " min-[500px]:grid-cols-2 grid-cols-1" : ""
                }`}
              >
                <CustomCheckbox
                  label=""
                  name="Options"
                  options={modifiedOp}
                  disabled={type === "info"}
                  isModalForm={isModalForm}
                  loading={loading}
                />
                {/* {modifiedOp?.length > 0 && (
                    <SingleSelectCheckboxGroup
                      options={modifiedOp}
                      type={type}
                      name="Options"
                      onChange={(vals) => setSelectedValues(vals)}
                      defaultOptionsValue={selectedValues}
                      disabled={type === "info"}
                    />
                  )} */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <SingleSelectCheckboxGroup
                      name="rest_api"
                      label="REST API:"
                      value={checkboxValues.rest_api}
                      onChange={(val) => updateGroupValue("rest_api", val)}
                      type={type}
                    />
                    <SingleSelectCheckboxGroup
                      name="log_api"
                      label="Log API:"
                      value={checkboxValues.log_api}
                      onChange={(val) => updateGroupValue("log_api", val)}
                      type={type}
                    />
                  </div> */}
              </div>
            </div>

            <div className="mt-3 border bg-white rounded-[4px] overflow-hidden">
              <div className="bg-gray-200 p-2.5 flex items-center">
                <DesktopOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  License Devices
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Camera"
                        name="Camera"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                    </Col> */}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Channel"
                      name="Channel"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "Channel must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="Channel"
                        name="Channel"
                        options={modifiedChannels}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Lockset"
                      name="Lockset"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "Lockset must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="Lockset"
                        name="Lockset"
                        options={modifiedLocksets}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Facegate"
                      name="Facegate"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "Facegate must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="Facegate"
                        name="Facegate"
                        options={modifiedFacegates}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="OSDP Device"
                      name="Subnode"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "OSDP Device must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="OSDP Device"
                        name="Subnode"
                        options={modifiedSubnodes}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>

                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Subnode"
                        name="Subnode"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                    </Col> */}

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Trilogy Lockset"
                      name="ContLock"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "Trilogy Lockset must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="Trilogy Lockset"
                        name="ContLock"
                        options={modifiedContLocks}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Intercom"
                      name="Intercom"
                      disabled={type === "info"}
                      type="number"
                      loading={loading}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value > 255) {
                              return Promise.reject(
                                new Error(
                                  "Intercom must be less than or equal to 255!"
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    />
                    {/* <CustomSelect
                        label="Intercom"
                        name="Intercom"
                        options={modifiedIntercoms}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Directory Extension"
                      name="Sicucom"
                      options={Array.from(
                        { length: (25500 - 100) / 100 + 1 },
                        (_, i) => {
                          const value = 100 + i * 100;
                          return {
                            value,
                            label: `${value}`,
                          };
                        }
                      )}
                      placeholder="Please select"
                      loading={loading}
                      disabled={type === "info"}
                    />
                    {/* <CustomSelect
                        label="Directory"
                        name="Sicucom"
                        options={modifiedSicucoms}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Mobile Credential"
                      name="Invitation"
                      options={Array.from(
                        { length: (25500 - 100) / 100 + 1 },
                        (_, i) => {
                          const value = 100 + i * 100;
                          return {
                            value,
                            label: `${value}`,
                          };
                        }
                      )}
                      placeholder="Please select"
                      disabled={type === "info"}
                      loading={loading}
                    />
                    {/* <CustomInput
                        label="Invitation"
                        name="Invitation"
                        disabled={type === "info"}
                        type="number"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (value && value < 100) {
                                return Promise.reject(
                                  new Error(
                                    "Invitation must be greater than or equal to 100!"
                                  )
                                );
                              }
                              if (value && value > 25500) {
                                return Promise.reject(
                                  new Error(
                                    "Invitation must be less than or equal to 25500!"
                                  )
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      /> */}
                    {/* <CustomSelect
                        label="Invitation"
                        name="Invitation"
                        options={modifiedInvitations}
                        placeholder="Please select"
                        disabled={type === "info"}
                      /> */}
                  </Col>
                </Row>

                {/* <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Storage"
                        name="Storage"
                        disabled={type === "info"}
                        type="number"
                        required
                      />
                      <CustomSelect
                        label="Storage"
                        name="Storage"
                        options={modifiedStorages}
                        placeholder="Please select"
                        disabled={type === "info"}
                      />
                    </Col>
                  </Row> */}
              </div>
            </div>
            {/* <div className="mt-3 border bg-white rounded-[4px] overflow-hidden">
                <div className="bg-gray-200 p-2.5 flex items-center">
                  <DollarOutlined className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                    License Price
                  </span>
                </div>
                <div className="px-2 pt-1 pb-3">
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Monthly"
                        name="Monthly"
                        disabled={type === "info"}
                        type="number"
                        required
                        prefix={"$"}
                        style={{ height: "30px" }}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="One Time"
                        name="OneTime"
                        disabled={type === "info"}
                        type="number"
                        required
                        prefix={"$"}
                        style={{ height: "30px" }}
                      />
                    </Col>
                  </Row>
                </div>
              </div> */}
          </>
        </div>
      </Form>
      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </>
  );
};
